import { canRead, canWrite } from '../access/rbacAccess'

export const ON_BOARD_SALES = {
  LIST: 'ejecuta.on_board_sales'
}

export const canViewOnBoardSales = () => canRead(ON_BOARD_SALES.LIST)

export const canManageOnBoardSales = () => canWrite(ON_BOARD_SALES.LIST)
